import React, { Component } from 'react'
import { Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  checkedDateListContains = text => {
    const { checkedDateList } = this.props
    if (checkedDateList.length == 0) {
      return true
    }
    return checkedDateList.indexOf(text) >= 0
  }

  getJobList = () => {
    const { fullReport } = this.props
    let jobList = []

    fullReport.forEach(item => {
      jobList.push(
        <div key={item.id}>
          <h5 className="steps">{item.name}</h5>
          {item.type === 'Maintenance/Service' && (
            <div className="row">
              {this.checkedDateListContains('Contract Expiration') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Contract Expiration</p>
                  <p>{moment(item.contract_expiration_date).format('YYYY-M-D')}</p>
                </div>
              )}
              {this.checkedDateListContains('Monthly Invoice Day') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Monthly Invoice Day</p>
                  <p>{item.monthly_invoice_day ? item.monthly_invoice_day : 'Not Entered'}</p>
                </div>
              )}
            </div>
          )}
          {item.type !== 'Maintenance/Service' && (
            <div className="row">
              {this.checkedDateListContains('Executed Contract') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Executed Contract</p>
                  <p>
                    {item.executed_contract_date
                      ? moment(item.executed_contract_date).format('YYYY-M-D')
                      : 'Not Entered'}
                  </p>
                </div>
              )}
              {this.checkedDateListContains('AIA Due Day') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">AIA Due Day</p>
                  <p>{item.aia_due_day ? item.aia_due_day : 'Not Entered'}</p>
                </div>
              )}
              {this.checkedDateListContains('AIA Expected Pay Day') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">AIA Expected Pay Day</p>
                  <p>{item.aia_expected_pay_day ? item.aia_expected_pay_day : 'Not Entered'}</p>
                </div>
              )}
            </div>
          )}
        </div>
      )
    })
    return jobList
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Financial Schedules</h5>
                  {this.getJobList()}
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/jobs/financial-schedules/ListItem.js